// extracted by css-extract-rspack-plugin
export default {"cls1":"feedback_option-cls1_4Fu","cls2":"feedback_option-cls2_ZE_ feedback_option-cls1_4Fu"};